import Splide from '@splidejs/splide';

const EL = '.js-gallery-slider'
const ACTIVE_CLASS = 'is-active'
const ELS = document.querySelectorAll(EL);

ELS.forEach((EL) => {
  new Splide( EL, {
    type   : 'loop',
    rewind: true,
    arrows: true,
    pagination: false,
    fixedWidth: '600px',
    gap: 60,
    focus: 'center',
    breakpoints: {
        1024: {
            fixedWidth: '400px',
            gap: 30,
        },
        767: {
            fixedWidth: '260px',
            gap: 20,
            arrows: false
        }
    }
  } ).mount();
});
